import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(value: any, format: string = 'MM-dd-yyyy'): string {
    if (!value) return '';
    try {
      const datePipe = new DatePipe('en-US');
      const formatted = datePipe.transform(value, format);
      return formatted || '';
    } catch (e) {
      return '';
    }
  }
}
